import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/main/Sidebar";
import TopBar from "../components/main/TopBar";
import { scrollToTop } from "../utils/scrollToTop";
import { useEffect } from "react";

function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex flex-col flex-1 w-0 relative">
        <main className="flex-1 overflow-y-auto">
          <TopBar />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
